import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const MonitoringState = () => {
  return (
    <FrameView
      title="Monitoring state"
      src="https://app.powerbi.com/view?r=eyJrIjoiY2FiMzk4NzgtMzU3Yi00ZDQ2LWE2MzktNTVjNTVjOTBkZDhjIiwidCI6ImZkYTc1ZGJiLTc5MjUtNGM5Ny1hM2NhLTNiZDJmZDU0OWU5MCIsImMiOjl9"
    />
  );
};
